const userRoleOptions = [
  'Broker',
  'Builder',
  'Captain',
  'Crew',
  'Engine Manufacturer',
  'Exterior Designer',
  'Family Office',
  'Interior Designer',
  'Legal, Financial, Insurance',
  'Luxury Industry',
  'Marina',
  'Marine Ancillary Services',
  'Naval Architect',
  "Owner's Representative",
  'Project Manager',
  'Refit & Maintenance',
  'Superyacht Enthusiast',
  'Superyacht Owner',
  'Technology Manufacturer',
  'Yacht Management Services',
  'Other'
].map(e => [e, e]);

export default userRoleOptions;
